import { ApiCustomFilter } from "../api-wrapper/setting/filterApi"
import { multipleSelectOptions } from "../types/settings"

const getFilterData = async () => {
  const profileId = localStorage.getItem("profileId")
  const storeArr: multipleSelectOptions[] = []
  const data = {
    profileId: profileId,
  }

  try {
    const customFilter = await ApiCustomFilter(data)
    customFilter.data.forEach((el) => {
      storeArr.push({
        value: el._id,
        label: el.filterName,
      })
    })
    return storeArr
  } catch (error) {
    console.error("Something went wrong")
  }
}

const customFilterService = {
  getFilterData,
}

export default customFilterService
